import React from 'react';
import MuiCssBaseline, { CssBaselineProps as MuiCssBaselineProps } from '@mui/material/CssBaseline';

export interface CssBaselineProps extends MuiCssBaselineProps {}

const CssBaseline = function CssBaseline(props: CssBaselineProps) {
  return <MuiCssBaseline {...props} />;
};

export default CssBaseline;
